
// Frontend version, normally the same as the backend version.
export const VERSION = "1.2.12";

// Logging verbosity (0=none, 9=extreme):
export const VERBOSITY = 3;

// base URL: /api for local, full URL for server:
export const API_BASE_URL = '/api';

export type RgbColor = {
  r: number;
  g: number;
  b: number;
};

export const PROC_ID_TO_COLOR: Record<string, RgbColor> = {
  proc911: { r: 146, g: 208, b: 80 },
  proc920: { r: 2, g: 114, b: 114 },
  proc923: { r: 2, g: 114, b: 114 },
  proc924: { r: 2, g: 114, b: 114 },
  proc926: { r: 2, g: 114, b: 114 },
  proc929: { r: 2, g: 114, b: 114 },
  proc934: { r: 2, g: 114, b: 114 },
  proc912: { r: 255, g: 255, b: 0 },
  proc921: { r: 0, g: 112, b: 192 },
  proc922: { r: 0, g: 112, b: 192 },
  proc711: { r: 15, g: 158, b: 213 },
  proc713: { r: 15, g: 158, b: 213 },
  proc311: { r: 255, g: 0, b: 0 },
  proc312: { r: 255, g: 0, b: 0 },
  proc313: { r: 255, g: 0, b: 0 },
  proc314: { r: 255, g: 0, b: 0 },
  proc315: { r: 255, g: 0, b: 0 },
  proc316: { r: 128, g: 128, b: 128 },
  proc925: { r: 242, g: 207, b: 238 },
  proc815: { r: 0, g: 203, b: 150 },
  proc816: { r: 229, g: 158, b: 221 },
  proc511: { r: 255, g: 41, b: 255 },
  proc512: { r: 255, g: 41, b: 255 },
  proc513: { r: 255, g: 41, b: 255 },
  proc514: { r: 255, g: 41, b: 255 },
  proc515: { r: 255, g: 41, b: 255 },
  proc516: { r: 255, g: 41, b: 255 },
  proc517: { r: 255, g: 41, b: 255 },
  proc518: { r: 255, g: 41, b: 255 },
  proc519: { r: 255, g: 41, b: 255 },
  proc520: { r: 255, g: 41, b: 255 },
  proc521: { r: 255, g: 41, b: 255 },
  proc522: { r: 255, g: 41, b: 255 },
  proc523: { r: 255, g: 41, b: 255 },
  proc524: { r: 255, g: 41, b: 255 },
};
